export const LEVEL_VISUALIZER_DELAY = 20
export const SOUND_TEST_URL =
  'https://sdk.twilio.com/js/client/sounds/releases/1.0.0/incoming.mp3'
